/**
 * Environment helpers using VITE_APP_ENV.
 * Values: local | development | staging | production
 * Production builds typically omit VITE_APP_ENV (undefined = production behavior).
 */
const appEnv = import.meta.env.VITE_APP_ENV as string | undefined;

const notProductionEnds = ['local', 'development', 'staging'];

/** Show error details in TenantErrorBoundary (local, development, staging) */
export const showErrorDetails = notProductionEnds.includes(appEnv);

/** Show destructive options like delete-tenant-data (local, development, staging) — never in production */
export const showDeleteTenantOption = notProductionEnds.includes(appEnv);

/** Local or development only (for pnpm vs node commands) */
export const isNotProduction = notProductionEnds.includes(appEnv);

/** Show pnpm commands (local, only) */
export const isLocal = appEnv === 'local';

/** Enable debug mode features (local, development, staging) */
export const isDebugEnv = notProductionEnds.includes(appEnv);

/** Frontend env for display — only when not production (undefined = production) */
export const frontendEnvForDisplay = notProductionEnds.includes(appEnv) ? appEnv : undefined;

/**
 * Marketing-site origin for docs / legal deep links.
 * Prefer `VITE_WEBSITE_URL` from the active Vite mode file; fall back to the
 * local website only in `vite` dev. Empty string means "hide external docs links".
 */
export const websiteUrl = (
  (import.meta.env.VITE_WEBSITE_URL as string | undefined)?.replace(/\/$/, '') ||
  (import.meta.env.DEV ? 'http://localhost:3002' : '')
);
